import { useState } from "react";
import { loadSalaryStructureDetail, loadSalaryStructureDetailByID } from "../services/salaryStructureService";

const useSalaryStructureDetailByID = () => {

    const [componentsDetail, setComponentsDetail] = useState([]);
    const [componentsList, setComponentsList] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const LoadSalaryStructureDetail = async (editSalaryStructureID = null) => {
        if (!isDataLoaded) {
            try {

                if (editSalaryStructureID !== 0) {
                    const payload = { p_companyid: localStorage.getItem('companyid'), p_plantid: 1, p_id_salary_structure: editSalaryStructureID };
                    const data = await loadSalaryStructureDetailByID(payload);
                    setComponentsDetail(Array.isArray(data) && data.length > 0 ? data : []);
                }
                else {
                    const payload = { p_companyid: localStorage.getItem('companyid')};
                    const data = await loadSalaryStructureDetail(payload);
                    setComponentsList(Array.isArray(data) && data.length > 0 ? data : []);
                }

            }
            catch (error) {
                console.log(error);
            }
            finally {
                setIsDataLoaded(true);
            }
        }
    }



    const LoadSalaryStructure = async(editSalaryStructureID) => {
        await LoadSalaryStructureDetail(editSalaryStructureID);
    }

    const LoadSalaryStructureDetailWithoutID = async() => {
        await LoadSalaryStructureDetail(0);
    }

    return {
        componentsDetail,
        componentsList,
        setComponentsDetail,
        setComponentsList,
        LoadSalaryStructure,
        LoadSalaryStructureDetailWithoutID,
    };

}
export default useSalaryStructureDetailByID;